import {
  Service
} from '../service.js'
import {
  env
} from '../env.js'

class ReferenciasDocumentoService extends Service {
  constructor() {
    super();

    this.url = env.url + "referencias-documentos";
  }

  async listarReferencias() {
    const referencias = await super.get(`${this.url}`);
    return referencias;
  }

  async getReferencia(id) {
    const referencia = await super.get(`${this.url}/${id}`);
    return referencia;
  }
}

export const referenciasDocumentosService = new ReferenciasDocumentoService()
